import Type from "@/model/types/Type";

const type = {
    PENDING : 1,
    OK : 2,
    HAS_PENDING_OCCURRENCE : 3,
    HAS_NEW_OCCURRENCE : 4,
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.OK,
        text: "Ok",
    },
    {
        value: type.HAS_PENDING_OCCURRENCE,
        text: "Apontamento anterior pendente",
    },
    {
        value: type.HAS_NEW_OCCURRENCE,
        text: "Apontamento nova",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


